module.exports = __webpack_public_path__ + "static/media/shelter_mooring_marker.335bf58f.svg";